module.exports = __webpack_public_path__ + "img/nkechi.8dfe67e3.png";